import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { IconOrbit } from '../components/icons';
import { EmptyState } from '../components/ui';
import { t } from '../i18n';

export function NotFoundPage() {
  const { user } = useAuth();

  return (
    <div className="page page--read">
      <EmptyState
        icon={<IconOrbit />}
        title={t('notfound.title')}
        body={t('notfound.body')}
        action={
          <div className="row" style={{ justifyContent: 'center' }}>
            <Link className="btn btn--primary" to={user ? '/app' : '/'}>
              {user ? t('notfound.feed') : t('notfound.home')}
            </Link>
            {user ? (
              <Link className="btn btn--outline" to="/app/library">
                {t('notfound.library')}
              </Link>
            ) : (
              <Link className="btn btn--outline" to="/register">
                {t('notfound.account')}
              </Link>
            )}
          </div>
        }
      />
    </div>
  );
}
